// components/ui/CreditsBadge.tsx
import React from 'react';
import clsx from 'clsx';
import { Sparkles } from '@/components/ui/lucide-memo';

interface CreditsBadgeProps {
  // Already formatted by the caller: the card and the top bar round to the integer, the
  // Generate button must keep its fractional quote (1.5 is not 2).
  value: string;
  size?: 'sm' | 'md';
  className?: string;
  title?: string;
}

const CreditsBadge: React.FC<CreditsBadgeProps> = React.memo(({ value, size = 'md', className, title }) => (
  <span
    title={title}
    className={clsx(
      'inline-flex items-center gap-1 py-0.5 font-medium rounded-md bg-white/5 text-white/50',
      size === 'sm' ? 'px-1.5 text-[10px]' : 'px-2 text-[11px]',
      className
    )}
  >
    <Sparkles size={10} />
    {value}
  </span>
));

CreditsBadge.displayName = 'CreditsBadge';
export default CreditsBadge;
